import { RequestBuilder, fetchAndRetryIfServerBusy } from '../utils/fetch';
import { SESSION_HEADER_EVENT_ID } from '../constants/Request';
import { ServiceError } from '../utils/errors';

/**
 * The event fee client
 * @param baseURL: string
 * @param eventId: string
 * @param environment: String
 */
export default class EventFeeClient {
  constructor(baseURL, eventId, environment) {
    this.eventFeeBaseUrl = baseURL + 'snapshot';
    this.environment = environment;
    this.eventId = eventId;
    this.request = new RequestBuilder({
      url: this.eventFeeBaseUrl
    })
      .withCookies()
      .header(SESSION_HEADER_EVENT_ID, eventId);
  }

  /**
   * Get all the fee available for an event
   * @param accessToken: string
   * @returns {Promise<*>}
   */
  async getEventFee(accessToken, regTypeId, eventSnapshotVersion) {
    let request = this.request
      .url(`${this.eventFeeBaseUrl}/${this.eventId}/fees`)
      .query('environment', this.environment);
    if (regTypeId) {
      request = request.query('registrationTypeId', regTypeId);
    }
    if (eventSnapshotVersion) {
      request = request.query('snapshotVersion', eventSnapshotVersion);
    }
    request = request.get()
      .auth(accessToken)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('Error retrieving event fee.', response, request);
    }
    if (response.status === 204) {
      return {};
    }
    return response.json();
  }
}
